import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "piped-response-value" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'BlankPollValue',
    props: {
        response: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.response.responseValues, (v, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                    (idx > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" ")
                        ], 64))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(v.pollLabel), 1)
                ], 64));
            }), 128));
        };
    }
});
